import { AppLayout } from './layout/AppLayout.tsx';
import { Route, Routes, useLocation } from 'react-router-dom';
import { routes } from './routes';
import { Login } from './app/Login.tsx';
import { DashboardRoute } from './dashboard/DashboardRoute.tsx';
import { useSentry } from './hooks/useSentry.ts';
import { StudentApplicationRoutes } from './routes/StudentApplicationRoutes.tsx';
import { HostFamilyRoutes } from './routes/HostFamilyRoutes.tsx';
import { LocalCoordinatorRoutes } from './routes/LocalCoordinatorRoutes.tsx';
import { PageTitleProvider } from '@enroller/utils';
import { getConfig } from './utils/config.ts';
import { ApplicationProvider } from './contexts/ApplicationContext/ApplicationProvider.tsx';

export const App = () => {
  useSentry();
  const { pageTitlePrefix } = getConfig();
  const { pathname } = useLocation();

  return (
    <PageTitleProvider pageTitlePrefix={pageTitlePrefix} pathname={pathname}>
      <ApplicationProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route index path="/" element={<DashboardRoute />} />
            <Route path={routes.login.url} element={<Login />} />
            <Route path={routes.callback.url} element={<></>} />
            <Route path={`${routes.application.url}/*`} element={<StudentApplicationRoutes />} />
            <Route path={`${routes.hostFamily.url}/*`} element={<HostFamilyRoutes />} />
            <Route path={`${routes.localCoordinator.url}/*`} element={<LocalCoordinatorRoutes />} />
          </Route>
        </Routes>
      </ApplicationProvider>
    </PageTitleProvider>
  );
};
